<div *transloco="let t; read: 'new-dashboard'" class="xi-modal__container new-dashboard__container">
  <h2 class="xi-modal__title">{{ title }}</h2>

  <div class="xi-modal__content">
    @if (isLoading.init) {
      <div class="xi-loader-container__center">
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    }
    @if (!isLoading.init) {
      <div class="dashboard-settings">
        <div class="block-title">{{ t('dashboard-settings') }}</div>
        <div class="input-block">
          <div class="new-dashboard__name-wrapper xi-input-field-wrapper">
            <xi-input-field
              [label]="t('dashboard-name')"
              [placeholder]="t('enter-here')"
              [(ngModel)]="dashboardName"
              name="dashboardName"
              required
              [prePopulateStatus]="true"
              [status]="dashboardNameStatus"
              (onChange)="nameValidator$.next(dashboardName)"
              appAutoFocus="xiInput"
            ></xi-input-field>
            @if (isLoading.validation) {
              <div class="xi-loader-container__inline-overlay">
                <xi-animation
                  [height]="75"
                  [width]="75"
                  [loop]="true"
                  animation="cx_loader"
                ></xi-animation>
              </div>
            }
          </div>
          <xi-text-area
            ngDefaultControl
            [(ngModel)]="note"
            name="note"
            [label]="t('notes')"
            [height]="100"
            [resize]="false"
            class="new-dashboard__notes"
          ></xi-text-area>
          <div class="new-dashboard__type">
            <xi-dropdown
              select="single"
              color="orca"
              [label]="t('type')"
              [stretch]="true"
              [disabled]="saveAsMode"
              [data]="dashboardTypeOptions"
              [value]="selectedDashboardTypeOption.id"
              (onValueChange)="onDashboardTypeChange($event.detail.selected)"
              [tooltipDisplayOnDisabled]="true"
              [tooltip]="dashboardTypeTooltip"
            ></xi-dropdown>
            <p>{{ selectedDashboardTypeOption.description }}</p>
          </div>
          <div class="new-dashboard__datasource">
            @if (isTemplate || selectedDashboardTypeOption.id !== traditionalDashboardTypeValue) {
              <label class="kxi-label">{{ t('datasource') }}</label>
              <app-data-source-chooser
                [disabled]="!isTemplate && saveAsMode"
                [dashboard]="dashboardForDataSource"
                [valuePlaceholder]="!isTemplate && saveAsMode ? t('no-change') : t('none')"
                [value]="selectedDataSource"
                [template]="selectedDashboardTypeOption.template"
                [dataSources]="datasourceManagerStore.getDatasources()"
                (datasourceSelected)="onDataSourceSelected($event)"
              >
              </app-data-source-chooser>
            }
          </div>
          <div class="new-dashboard__sentiment-scale">
            <div class="new-dashboard__radio-label">{{ t('sentiment-scale') }}</div>
            <div class="kxi-text-600 new-dashboard__radio">
              <xi-radio
                [value]="3"
                [label]="t('three-point')"
                name="sentimentScaleRadio"
                [(ngModel)]="sentimentScale"
                [disabled]="saveAsMode"
                [checked]="sentimentScale === '3'"
              ></xi-radio>
              <xi-radio
                [value]="5"
                [label]="t('five-point')"
                name="sentimentScaleRadio"
                [(ngModel)]="sentimentScale"
                [disabled]="saveAsMode"
                [checked]="sentimentScale === '5'"
              ></xi-radio>
            </div>
          </div>
          <div class="new-dashboard__sentiment-display">
            <div class="new-dashboard__radio-label">{{ t('sentiment-display') }}</div>
            <div class="kxi-text-600 new-dashboard__radio">
              <xi-radio
                [value]="'polarity'"
                [label]="t('polarity')"
                name="sentimentDisplayRadio"
                [(ngModel)]="sentimentDisplay"
                [disabled]="saveAsMode"
                [checked]="sentimentDisplay === 'polarity'"
              ></xi-radio>
              <xi-radio
                [value]="'numeric'"
                [label]="t('numeric')"
                name="sentimentDisplayRadio"
                [(ngModel)]="sentimentDisplay"
                [disabled]="saveAsMode"
                [checked]="sentimentDisplay === 'numeric'"
              ></xi-radio>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="xi-modal__actions new-dashboard__action">
    <div class="xi-loader-button-container" [matTooltip]="formState.message">
      <xi-default-button
        [text]="t('create-dashboard')"
        [disabled]="!canCreateDashboard()"
        (onClick)="createDashboard()"
      ></xi-default-button>

      @if (isLoading.save) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>
</div>
